import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddCategoryForm from './form/addForm';
import { createCategory } from './_api';
import { get } from 'lodash';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withRouter,
  withSnackbar,
  withHandlers({
    onSubmit: ({ history, toggleLoader, enqueueSnackbar }) => async values => {
      toggleLoader();
      const resp = await createCategory(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Kategorie byla úspěšně vytvořena.', { variant: 'success' });
        history.push('/categories');
      } else {
        enqueueSnackbar('Kategorii se nepodařilo vytvořit.', { variant: 'error' });
      }
      toggleLoader(false);
    },
  }),
);

export default enhance(({ classes, onSubmit }) => (
  <div className={classes.root}>
    <h3>Přidat kategorii</h3>
    <Paper className={classes.paper}>
      <AddCategoryForm onSubmit={onSubmit} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/categories/add.js